import { render, staticRenderFns } from "./SortAlphabeticalAscending.vue?vue&type=template&id=6ef9b586"
import script from "./SortAlphabeticalAscending.vue?vue&type=script&lang=js"
export * from "./SortAlphabeticalAscending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports